// @ vendors
const { Promise } = require('es6-promise');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');

// @ actions
const { requestInsuranceCurrentState } = require('./insuranceRequestState');

// @ constants
const { INSURANCES_HOME_REQUEST, INSURANCES_LANDING } = require('../../insuranceConstants/insuranceRequestRoutes');
const {
    INSURANCE_REQUEST_SIMULATION_LINK_CLIENT_REQUEST,
    INSURANCE_REQUEST_SIMULATION_LINK_CLIENT_SUCCESS,
    INSURANCE_REQUEST_SIMULATION_LINK_CLIENT_FAILURE,
    INSURANCE_REQUEST_SIMULATION_CANCEL_REQUEST,
    INSURANCE_REQUEST_SIMULATION_CANCEL_SUCCESS,
    INSURANCE_REQUEST_SIMULATION_CANCEL_FAILURE,
    INSURANCE_REQUEST_SIMULATION_RESET
} = require('../../insuranceConstants/actionTypes');
const {
    PRE_CONTRACTUAL_NO_RELATED_INSURANCE_MAIL,
} = require('constants/flagBasedFeatures');

const linkClientInProgress = token => ({
    type: INSURANCE_REQUEST_SIMULATION_LINK_CLIENT_REQUEST,
    data: { token }
});

const linkClientSuccess = id => ({
    type: INSURANCE_REQUEST_SIMULATION_LINK_CLIENT_SUCCESS,
    data: { id }
});

const linkClientFailure = error => ({
    type: INSURANCE_REQUEST_SIMULATION_LINK_CLIENT_FAILURE,
    data: { error }
});

const cancelSimulationInProgress = () => ({
    type: INSURANCE_REQUEST_SIMULATION_CANCEL_REQUEST
});

const cancelSimulationSuccess = id => ({
    type: INSURANCE_REQUEST_SIMULATION_CANCEL_SUCCESS,
    data: { id }
});

const cancelSimulationFailure = error => ({
    type: INSURANCE_REQUEST_SIMULATION_CANCEL_FAILURE,
    data: { error }
});

const resetSimulationData = () => ({
    type: INSURANCE_REQUEST_SIMULATION_RESET
});

const linkClient = (token, history) => (dispatch, getState) => {
    const currentState = getState().insuranceRequestSimulation;
    const immFlagBasedFeatures = getState().flagBasedFeatures;

    if (!currentState.get('isFetching')) {
        dispatch(linkClientInProgress(token));

        const requestData = {
            query: {
                'simulationToken': token
            }
        };

        if (immFlagBasedFeatures.get(PRE_CONTRACTUAL_NO_RELATED_INSURANCE_MAIL)) {
            if (__CONTACT_CENTER__) {
                requestData['header'] = {
                    version: '3',
                }
            } else {
                requestData['header'] = {
                    version: '2',
                }
            }
        }

        return APIPost(
            dispatch,
            apiURLBuilder.getURL('insuranceRequestSimulationLinkClient'),
            requestData
        )
            .then(response => {
                dispatch(linkClientSuccess(response.data));
                requestInsuranceCurrentState(true)(dispatch, getState);
                history.push(INSURANCES_HOME_REQUEST)
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(linkClientFailure(response.error));
                    history.push(INSURANCES_LANDING);
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

const cancelSimulation = (simulationToken, history) => (dispatch, getState) => {
    const cancelInProgress = getState().insuranceRequestSimulation.get('isFetchingCancel');

    if (!cancelInProgress) {
        dispatch(cancelSimulationInProgress());
        return APIPost({
            dispatch,
            endpoint: 'insuranceRequestCancelQuotation'
        })
            .then(() => {
                dispatch(cancelSimulationSuccess());

                if (simulationToken) {
                    dispatch(linkClient(simulationToken, history));
                } else {
                    return requestInsuranceCurrentState()(dispatch, getState);
                }
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(cancelSimulationFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

const resetSimulation = () => dispatch => {
    dispatch(resetSimulationData());
};

module.exports = {
    linkClient,
    cancelSimulation,
    resetSimulation
};
